import { FormGroupRules } from '@shared/models/interfaces/form-group-rules.model';
import { FormGroup } from '@angular/forms';
import { conclusioniCkHelper } from './helpers/conclusioni-form.helper';

export const conclusioniPropostaGestioneCommRules: FormGroupRules = {
    my_ckProspettScopoSoc: (form: FormGroup) => {
        conclusioniCkHelper(form, 'my_SchedaPropostaGestioneComm.my_ckProspettScopoSoc', 'my_CkProvvedimendoDi', 2);
    },

    my_descProspettScopoSoc: (form: FormGroup) => {
        conclusioniCkHelper(form, 'my_SchedaPropostaGestioneComm.my_descProspettScopoSoc', 'my_CkProvvedimendoDi', 2);
    },

    my_ckRisFinProsecuzioneAttSoc: (form: FormGroup) => {
        conclusioniCkHelper(form, 'my_SchedaPropostaGestioneComm.my_ckRisFinProsecuzioneAttSoc', 'my_CkProvvedimendoDi', 2);
    },

    my_descRisFinProsecuzioneAttSoc: (form: FormGroup) => {
        conclusioniCkHelper(form, 'my_SchedaPropostaGestioneComm.my_descRisFinProsecuzioneAttSoc', 'my_CkProvvedimendoDi', 2);
    },

    my_descInizCommGovernativo: (form: FormGroup) => {
        conclusioniCkHelper(form, 'my_SchedaPropostaGestioneComm.my_descInizCommGovernativo', 'my_CkProvvedimendoDi', 2);
    },
};
